import React from "react";
import styled from "@emotion/styled";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import { grayUnselectedRadioColorProps } from "../../../../../../../componentThemes";

const ChartToggle = ({ handleTimelineChange, chartTimeline, handleChartPerspectiveChange, chartPerspective }) => {
  const perspectiveProps = (item) => ({
    checked: chartPerspective === item,
    onChange: handleChartPerspectiveChange,
    value: item,
    label: item,
    labelPlacement: "start",
  });
  const timelineControlProps = (item) => ({
    checked: chartTimeline === item,
    onChange: handleTimelineChange,
    value: item,
    label: item,
    labelPlacement: "start",
  });

  return (
    <ToggleShell>
      <ToggleGroup>
        <ToggleLabel>Perspective</ToggleLabel>
        <FormControl>
          <StyledRadioGroup row>
            <StyledFormControlLabel
              control={<Radio {...grayUnselectedRadioColorProps()} />}
              {...perspectiveProps('Monthly Stats')} 
            />
            <StyledFormControlLabel
              control={<Radio {...grayUnselectedRadioColorProps()} />}
              {...perspectiveProps('Historical Profit')} 
            />
          </StyledRadioGroup>
        </FormControl>
      </ToggleGroup>
      {chartPerspective === 'Monthly Stats' ?
        <ToggleGroup>
          <ToggleLabel>Timeframe</ToggleLabel>
          <FormControl>
            <StyledRadioGroup row>
              <StyledFormControlLabel
                control={<Radio {...grayUnselectedRadioColorProps()} />}
                {...timelineControlProps('All')} 
              />
              <StyledFormControlLabel
                control={<Radio {...grayUnselectedRadioColorProps()} />}
                {...timelineControlProps('1 Year')} 
              />
              <StyledFormControlLabel
                control={<Radio {...grayUnselectedRadioColorProps()} />}
                {...timelineControlProps('2 Year')} 
              />
            </StyledRadioGroup>
          </FormControl>
        </ToggleGroup>
      :
        <></>
      }
    </ToggleShell>
  )
}

const ToggleShell = styled.div(({ theme }) => `
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.85rem;
  flex-wrap: wrap;
  color: ${theme.palette.common.grayText};
`)

const ToggleGroup = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 0.7rem;
`

const ToggleLabel = styled.div(({ theme }) => `
  padding-right: 0.7rem;
  border-right: 0.1rem solid ${theme.palette.common.grayBorderDark};
  color: ${theme.palette.common.grayText};
  font-size: 0.82rem;
  font-weight: 800;
  line-height: 1.2;
`)

const StyledRadioGroup = styled(RadioGroup)`
  gap: 0.1rem;
`

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => `
  margin: 0;
  color: ${theme.palette.common.grayText};

  .MuiFormControlLabel-label {
    color: ${theme.palette.common.grayText};
    font-size: 0.8rem;
    font-weight: 750;
    line-height: 1.2;
  }

  .MuiRadio-root {
    padding: 0.18rem;
  }
`)

export default ChartToggle;
